// src/store/live/selectors.js
import { createSelector } from '@reduxjs/toolkit'
import { EMPTY_ARRAY } from '~/lib/constants'
import { selectLive } from './effect_selectors'

const logger = console.scope('live-selectors')

/** `selectLive` and one generated `select<Effect>Params` per effect. ⚠️ `export *`, not a named list — a list is a second per-effect enumeration and goes stale silently when an effect lands. */
export * from './effect_selectors'

// objects

export const selectObjects = createSelector(selectLive, live => live.objects)

export const selectChildren = createSelector([selectObjects, (_, id) => id], (objects, id) => {
	const obj = objects[id]
	if (!obj?.children) return EMPTY_ARRAY
	if (!Array.isArray(obj.children)) {
		logger.error('selectChildren: children is not an array', obj)
		return EMPTY_ARRAY
	}
	const children = obj.children
		.map(childId => {
			if (!objects[childId]) {
				logger.warn('selectChildren: dangling child reference', childId, 'in', id)
				return null
			}
			return objects[childId]
		})
		.filter(Boolean)
	return children
})

export const selectObjectById = createSelector([selectObjects, (_, id) => id], (objects, id) => objects[id])

export const selectObjectsById = createSelector([selectObjects, (_, ids) => ids], (objects, ids) => {
	if (!ids) {
		logger.error('selectObjectsById: No ids provided')
		return EMPTY_ARRAY
	}
	if (!Array.isArray(ids)) ids = [ids]

	return ids.map(id => objects[id])
})
